import { put, takeLatest } from '@redux-saga/core/effects'
import { select } from 'redux-saga/effects'
import { getSingleSelectPageSelector } from '../selectors/getSingleSelectPage.selector'
import { ISingleSelectPageState } from '../store/singleSelectPage.types'
import * as actions from '../store/singleSelectPage.actions'
import { ISearchState } from '../../search/store/search.types'
import { getSearchStateSelector } from '../../search/selectors'
import { SearchConstants } from '../../search/store/search.constants'
import { IOption } from '../../../common/common.types'

export function* setFilteredCommonOptions() {
  const singleSelectPageState: ISingleSelectPageState = yield select(getSingleSelectPageSelector)
  const { commonOptions, options } = singleSelectPageState
  const searchState: ISearchState = yield select(getSearchStateSelector)
  const { searchText } = searchState
  if (options && options.length) {
    if (searchText) {
      const filteredCommonOptions = commonOptions.filter((o: IOption) =>
        o.name?.toLowerCase().includes(searchText.toLowerCase().trim())
      )
      yield put(actions.setFilteredCommonOptions(filteredCommonOptions))
    } else {
      yield put(actions.setFilteredCommonOptions(commonOptions))
    }
  }
}

export function* setFilteredCommonOptionsSaga() {
  yield takeLatest([SearchConstants.SET_FILTERED_OPTIONS], setFilteredCommonOptions)
}
